import React from 'react';

export const IssuesHeader = ({
  className,
  color,
  width,
  height,
}: {
  className?: string;
  color?: string;
  width?:number;
  height?:number;
}) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.6081 5.88574H14.902L8.87896 21.3539H16.7554L11.813 36.2084L31.2734 15.093H22.161L32.6081 5.88574Z"
      stroke="#5D54C0"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
